module.exports = __webpack_public_path__ + "fonts/Gilroy-SemiBoldItalic.eebe073a.eot";